import React, { useEffect } from "react";

const THEME = "#8b1634";

export default function Sf009DiagramImagePreviewModal({ src, title, onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.6)", zIndex: 2100 }}
      tabIndex={-1}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "min(92vw, 720px)", width: "100%" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-content"
          style={{ borderRadius: 14, overflow: "hidden", border: "none", boxShadow: "0 25px 60px rgba(0,0,0,0.35)" }}
        >
          <div className="modal-header" style={{ borderBottom: "1px solid #e2e8f0", padding: "12px 16px" }}>
            <h5 className="modal-title" style={{ margin: 0, fontWeight: 700, fontSize: 16, color: "#111827" }}>
              {title || "Diagram preview"}
            </h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
          </div>
          <div
            style={{
              background: "#0f172a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 280,
              maxHeight: "70vh",
              overflow: "auto",
              padding: 12,
            }}
          >
            <img
              src={src}
              alt={title || "Diagram"}
              style={{ maxWidth: "100%", maxHeight: "65vh", objectFit: "contain", borderRadius: 10 }}
            />
          </div>
          <div className="modal-footer" style={{ borderTop: "1px solid #e2e8f0", padding: "10px 16px" }}>
            <button
              type="button"
              className="btn"
              style={{
                border: `1px solid ${THEME}`,
                color: THEME,
                background: "transparent",
                fontWeight: 600,
                borderRadius: 8,
              }}
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
